import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router";

import { AdminPage } from "@/pages/AdminPage";
import { LoginPage } from "@/pages/LoginPage";
import { MailPage } from "@/pages/MailPage";
import { NotFoundPage } from "@/pages/NotFoundPage";
import { PendingPage } from "@/pages/PendingPage";
import { SignupPage } from "@/pages/SignupPage";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 메일은 SSE로 밀어주므로 폴링에 기대지 않는다
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

/**
 * 화면은 전부 주소에서 온다.
 *
 * 경로가 "무엇을 보고 있는가"(방·원문)를, 쿼리스트링이 "어떻게 걸러 보는가와
 * 무엇이 겹쳐 떠 있는가"(필터·검색어·모달)를 맡는다. 나눈 기준은 **링크로
 * 줬을 때 같은 것이 열려야 하는가**다 — 방과 원문은 그 자체가 목적지지만,
 * 필터는 같은 목적지를 보는 방식이다.
 *
 * 모달까지 주소에 얹는 이유는 뒤로가기다. state로만 들고 있으면 뒤로가기가
 * 모달을 닫는 대신 앱을 통째로 벗어난다.
 */
export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          {/* 가입은 누구나. 다만 최고 관리자가 받아줘야 열린다 (docs/plan.md) */}
          <Route path="/signup" element={<SignupPage />} />
          {/* 승인을 기다리는 사람이 보는 곳 */}
          <Route path="/pending" element={<PendingPage />} />
          {/* 받아주는 곳. 관리자가 아니면 메일함으로 되돌린다 */}
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/" element={<MailPage />} />
          {/* 대화 하나를 링크로 열 수 있게 한다 */}
          <Route path="/r/:roomId" element={<MailPage />} />
          {/* 원문 메일 화면. 전체를 덮으므로 주소도 따로 가진다 */}
          <Route path="/r/:roomId/m/:messageId" element={<MailPage />} />
          {/* 어디에도 안 걸리면 흰 화면 대신 그렇게 말해준다 */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
